import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ADR_EDIT } from "../../_constants/actionConstants";
import { getEquipCodeLine } from "./utils/adrUtilsV3";

export default function AdrEquipmentRemarksModalV3(props) {
  const {
    showModal,
    toggleModal,
    projectId,
    rowKey,
    tabId,
    equipmentId,
    remarks,
    markAdrDirty,
  } = props;

  const dispatch = useDispatch();

  const projEquipList = useSelector(
    (state) => state.equipment.projEquipLists[projectId] || null
  );

  const equipment = useMemo(
    () => (projEquipList || []).find((e) => e.equipmentId === equipmentId) || null,
    [projEquipList]
  );

  const [_remarks, setRemarks] = useState(remarks || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch({
      type: ADR_EDIT.EQUIPMENTSET.REMARKS.UPDATE,
      tabId,
      rowKey,
      remarks: _remarks,
    });
    toggleModal();
    markAdrDirty();
  };

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={showModal} toggle={toggleModal} fade={false} size={"md"}>
      <ModalHeader toggle={toggleModal} className="bg-info text-white" close={closeBtn}>
        <FontAwesomeIcon icon="comment-dots" className="fa-fw mr-2" />
        Edit Equipment Remarks
      </ModalHeader>
      <ModalBody>
        <div className="card mx-2 mb-2">
          <div className="card-body">
            <div className="form-row mb-1">{getEquipCodeLine(equipment)}</div>
            <div className="form-row form-group mb-0">
              <label className="mb-0" htmlFor="remarks">
                <b>Remarks:</b>
              </label>
              <textarea
                name="remarks"
                id="remarks"
                rows="3"
                className="form-control"
                value={_remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="bg-lightgray">
        <div className="form-row form-group mb-0">
          <input
            className="btn btn-primary"
            name="addOperator"
            type="submit"
            form="editLaborRemarksForm"
            onClick={handleSubmit}
            value="Save"
          />
          <button
            className="btn btn-secondary ml-2"
            color="secondary"
            onClick={toggleModal}
          >
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
